// 中文翻译
const common = {
  // 导航栏
  "nav.home": "首页",
  "nav.generator": "AI生成器",
  "nav.pricing": "定价",
  "nav.login": "登录 / 注册",
  "nav.startFree": "免费开始创作",
  "nav.memberCenter": "会员中心",
  "nav.logout": "退出登录",

  // 英雄区
  "hero.badge": "100% 永久免费 • 无需登录 • 无限使用",
  "hero.title1": "免费 AI 图像",
  "hero.title2": "生成器",
  "hero.subtitle": "用 AI 将你的想法瞬间转化为惊艳的视觉作品。\n无需注册，无限生成，完全免费。",
  "hero.ctaPrimary": "开始免费创作",
  "hero.ctaSecondary": "查看如何使用",
  "hero.trust1": "无需信用卡",
  "hero.trust2": "无限使用",
  "hero.trust3": "商用授权",

  // 功能区
  "features.badge": "功能特性",
  "features.title": "强大的 AI 图像生成",
  "features.subtitle": "体验为创作者设计的下一代 AI 图像创作与尖端功能",
  "features.f1.title": "文本生成图像",
  "features.f1.desc": "使用先进的 AI 模型将您的文字转化为惊艳的视觉效果。只需描述您想看到的内容。",
  "features.f2.title": "图像转图像",
  "features.f2.desc": "上传任何图像并即时将其转换为不同风格、增强质量或创建变体。",
  "features.f3.title": "风格迁移",
  "features.f3.desc": "为您的图像应用艺术风格。从写实到动漫，从油画到数字艺术。",
  "features.f4.title": "闪电般快速",
  "features.f4.desc": "通过我们优化的 AI 基础设施在几秒钟内生成专业质量的图像。",
  "features.f5.title": "隐私保护",
  "features.f5.desc": "零数据保留政策。您的提示词和图像永远不会存储在我们的服务器上。",
  "features.f6.title": "无限且免费",
  "features.f6.desc": "无使用限制，无需信用卡，无需注册。永远随心所欲地创作。",

  // 画廊区
  "gallery.badge": "画廊",
  "gallery.title": "获取灵感",
  "gallery.subtitle": "探索我们社区创作的惊艳 AI 生成图像",
  "gallery.cta": "创作您自己的",
  "gallery.clickToUse": "点击使用",
  "gallery.copyPrompt": "复制提示词",
  "gallery.copied": "已复制！",
  "gallery.usePrompt": "使用此提示词",
  "gallery.hoverTip": "悬停在任何图像上以复制或使用其提示词",

  // 统计区
  "stats.title": "受数百万用户信赖",
  "stats.subtitle": "加入全球最大的免费 AI 图像生成器社区",
  "stats.s1.label": "活跃用户",
  "stats.s1.value": "300万+",
  "stats.s1.desc": "月活跃用户",
  "stats.s2.label": "已创建图像",
  "stats.s2.value": "1,530",
  "stats.s2.desc": "每分钟生成图像数",
  "stats.s3.label": "用户评分",
  "stats.s3.value": "4.9",
  "stats.s3.desc": "平均质量评分",

  // 评价区
  "testimonials.badge": "用户评价",
  "testimonials.title": "创作者的评价",
  "testimonials.subtitle": "看看创作者如何使用我们的 AI 提升生产力",
  "testimonials.ratings": "基于 25,017+ 用户评分，平均 4.9/5 星",
  "testimonials.t1.name": "Sophie Miller",
  "testimonials.t1.role": "自由设计师",
  "testimonials.t1.content": "这个 AI 图像生成器让我的创作效率提升了 10 倍！图像质量超乎想象，完美满足商业需求。",
  "testimonials.t2.name": "Michael Chen",
  "testimonials.t2.role": "创意总监",
  "testimonials.t2.content": "凭借先进的功能，我可以精确控制每一个细节。这是市场上最强大的 AI 图像生成器！",
  "testimonials.t3.name": "Sarah Wang",
  "testimonials.t3.role": "电商经理",
  "testimonials.t3.content": "作为电商经理，这个工具帮助我快速生成产品展示图像。效果远超其他 AI 工具！",
  "testimonials.t4.name": "David Liu",
  "testimonials.t4.role": "品牌设计师",
  "testimonials.t4.content": "编辑器让我能够保持品牌风格的一致性。这个 AI 图像生成器真正理解我的需求。",
  "testimonials.t5.name": "Emma Zhang",
  "testimonials.t5.role": "内容创作者",
  "testimonials.t5.content": "速度令人惊叹！几秒钟内生成专业质量的图像，大大缩短了项目周期。",
  "testimonials.t6.name": "Kevin Wu",
  "testimonials.t6.role": "游戏概念艺术家",
  "testimonials.t6.content": "细节表现无与伦比。作为游戏开发者，这已成为我们概念设计的首选工具。",

  // CTA 区
  "cta.title1": "准备创作",
  "cta.title2": "惊艳的 AI 艺术？",
  "cta.subtitle": "加入数百万创作者，使用世界上最强大的免费 AI 图像生成器",
  "cta.button": "免费生成您的第一张图像",
  "cta.note": "无需信用卡 • 无需注册 • 无限生成",

  // FAQ 区
  "faq.badge": "常见问题",
  "faq.title": "常见问题解答",
  "faq.contact": "还有更多问题？请联系我们：support@aiimagegenrator.com",
  "faq.q1": "什么是 AI 图像生成器，它是如何工作的？",
  "faq.a1": "我们的 AI 图像生成器是世界上第一个完全免费、无限制的 AI 图像创作工具。它使用先进的 AI 模型从文本描述创建高质量图像，无需注册或使用限制。",
  "faq.q2": "这个 AI 图像生成器真的免费使用吗？",
  "faq.a2": "是的，我们的 AI 图像生成器完全免费使用！我们致力于成为世界上最大、最强大的免费 AI 图像生成器。没有隐藏费用，无需信用卡，没有使用限制。",
  "faq.q3": "这与其他 AI 图像生成器有什么不同？",
  "faq.a3": "我们的 AI 图像生成器是唯一提供无限免费使用并智能路由多个 AI 模型的平台。我们提供卓越的图像质量、快速的生成速度和完整的隐私保护，所有这些都是免费的，无需注册。",
  "faq.q4": "我需要创建账户才能使用吗？",
  "faq.a4": "不需要账户！我们的 AI 图像生成器让您访问后立即开始生成图像。我们相信让 AI 无障碍访问。",
  "faq.q5": "我可以创建什么类型的图像？",
  "faq.a5": "我们的 AI 图像生成器允许您创建各种类型的图像，包括写实场景、艺术插图、数字艺术、动漫风格图像等。",
  "faq.q6": "这如何保护我的隐私？",
  "faq.a6": "我们非常重视隐私。我们不会在服务器上存储您的提示词或生成的图像，也不需要任何个人信息。您的创作完全保密。",
  "faq.q7": "我可以将生成的图像用于商业目的吗？",
  "faq.a7": "是的，您拥有使用我们的 AI 图像生成器生成的图像的权利。您可以将它们用于个人和商业目的，非常适合创作者和企业。",
  "faq.q8": "这在移动设备上可用吗？",
  "faq.a8": "目前，您可以通过我们的网站访问我们的 AI 图像生成器，它在移动浏览器上运行良好。我们正在积极开发专用的移动应用程序，以提供更好的体验。",

  // 定价区
  "pricing.title": "简单透明的定价",
  "pricing.subtitle": "完全免费，无需付费，享受所有功能",
  "pricing.monthly": "月付",
  "pricing.yearly": "年付",
  "pricing.save17": "节省 17%",
  "pricing.popular": "最受欢迎",
  "pricing.guarantee": "30天退款保证",
  "pricing.loginPrompt": "请先登录以升级到 Pro",
  "pricing.free.name": "完全免费",
  "pricing.free.desc": "永久免费使用所有 AI 生图功能",
  "pricing.free.cta": "立即开始免费使用",
  "pricing.free.f1": "无限图片生成",
  "pricing.free.f2": "高质量输出 (1024x1024)",
  "pricing.free.f3": "所有风格和滤镜",
  "pricing.free.f4": "无需登录注册",
  "pricing.free.f5": "无水印",
  "pricing.free.f6": "快速生成速度",
  "pricing.pro.name": "专业版",
  "pricing.pro.desc": "适合专业人士和内容创作者",
  "pricing.pro.cta": "升级到专业版",
  "pricing.pro.f1": "无限图像",
  "pricing.pro.f2": "高质量 (1024x1024)",
  "pricing.pro.f3": "高级风格和滤镜",
  "pricing.pro.f4": "优先支持",
  "pricing.pro.f5": "无水印",
  "pricing.pro.f6": "快速生成速度",
  "pricing.pro.f7": "批量生成（最多 10 张）",
  "pricing.pro.f8": "商业许可",
  "pricing.pro.f9": "高级 AI 模型",
  "pricing.pro.f10": "图像放大",
  "pricing.pro.saveYear": "每年节省 $30",
  "pricing.paypalCheckout": "通过 PayPal 完成订阅",
  "pricing.cancelPayment": "取消",
  "pricing.subscriptionSuccess": "订阅成功！欢迎使用专业版！",

  // 对比表
  "compare.title": "详细对比",
  "compare.subtitle": "查看每个计划包含的内容",
  "compare.feature": "功能",
  "compare.free": "免费版",
  "compare.pro": "专业版",
  "compare.f1": "图像生成",
  "compare.v1.free": "无限",
  "compare.v1.pro": "无限",
  "compare.f2": "最大分辨率",
  "compare.v2.free": "1024x1024",
  "compare.v2.pro": "4096x4096",
  "compare.f3": "生成速度",
  "compare.v3.free": "标准",
  "compare.v3.pro": "3 倍快",
  "compare.f4": "批量生成",
  "compare.v4.free": "5 张图像",
  "compare.v4.pro": "20 张图像",
  "compare.f5": "风格选项",
  "compare.v5.free": "基础",
  "compare.v5.pro": "高级",
  "compare.f6": "编辑工具",
  "compare.v6.free": "基础",
  "compare.v6.pro": "高级",
  "compare.f7": "广告",
  "compare.v7.free": "有",
  "compare.v7.pro": "无",
  "compare.f8": "优先支持",
  "compare.v8.free": "无",
  "compare.v8.pro": "有",
  "compare.f9": "商业许可",
  "compare.v9.free": "有",
  "compare.v9.pro": "有",
  "compare.f10": "水印",
  "compare.v10.free": "无",
  "compare.v10.pro": "无",

  // 生成器页面
  "gen.title": "AI 图像生成器",
  "gen.subtitle": "使用 AI 创建惊艳图像 - 免费、无限、无需登录",
  "gen.mode": "生成模式",
  "gen.textToImage": "文本生成图像",
  "gen.imageToImage": "图像转图像",
  "gen.aspectRatio": "宽高比",
  "gen.style": "风格",
  "gen.style.none": "无风格",
  "gen.style.realistic": "写实",
  "gen.style.anime": "动漫",
  "gen.style.artistic": "艺术",
  "gen.style.digital": "数字艺术",
  "gen.promptLabel": "描述您想要创建的内容",
  "gen.promptPlaceholder": "一个美丽的日落，山脉上有鲜艳的色彩...",
  "gen.promptTip": "💡 提示：具体和描述性的提示词可获得最佳效果",
  "gen.uploadLabel": "上传源图像",
  "gen.uploadHint": "点击上传或拖放",
  "gen.uploadSize": "PNG、JPG 最大 10MB",
  "gen.generateBtn": "生成图像",
  "gen.free": "免费",
  "gen.resultPlaceholder": "您生成的图像将显示在这里",
  "gen.emptyPrompt": "请输入提示词以生成图像",
  "gen.promptPrefilled": "✨ 提示词已从画廊填充！点击生成以创建您的图像。",
  "gen.clearPrompt": "清除",

  // 生成器标签页和新键
  "gen.tabSingle": "单图生成",
  "gen.tabBatch": "批量生成",
  "gen.tabHistory": "历史记录",
  "gen.successMsg": "图像生成成功！",
  "gen.generating": "生成中...",
  "gen.download": "下载图像",
  "gen.new": "新建",

  // 图像历史
  "history.title": "生成历史",
  "history.empty": "尚未生成图像",
  "history.emptyHint": "您生成的图像将显示在这里",
  "history.clearAll": "清除全部",
  "history.clearConfirmTitle": "清除所有历史记录？",
  "history.clearConfirmDesc": "这将永久删除您的所有生成历史记录。此操作无法撤消。",
  "history.cancel": "取消",
  "history.clearConfirm": "清除全部",
  "history.reuse": "使用此提示词",
  "history.download": "下载",
  "history.copyPrompt": "复制提示词",
  "history.justNow": "刚刚",
  "history.minutesAgo": "{{count}} 分钟前",
  "history.hoursAgo": "{{count}} 小时前",
  "history.daysAgo": "{{count}} 天前",

  // 批量生成
  "batch.title": "批量生成",
  "batch.badge": "专业功能",
  "batch.countLabel": "要生成的图像数量",
  "batch.images": "张图像",
  "batch.generateBtn": "生成 {{count}} 张图像",
  "batch.generating": "生成中",
  "batch.progressText": "已完成 {{done}} / {{total}} 张图像",
  "batch.results": "生成的图像",
  "batch.downloadAll": "下载全部",
  "batch.hint": "在左侧输入提示词，然后一次生成多个变体",

  // 图像转视频
  "gen.tabI2V": "图像转视频",
  "i2v.title": "图像转视频",
  "i2v.uploadTitle": "上传或粘贴图像",
  "i2v.uploadHint": "点击上传、拖放或 Ctrl+V 粘贴",
  "i2v.uploadFormats": "PNG、JPG、WebP 最大 20MB",
  "i2v.changeImage": "更换",
  "i2v.effectLabel": "运动效果",
  "i2v.effectZoomIn": "放大",
  "i2v.effectZoomOut": "缩小",
  "i2v.effectPanLeft": "向左平移",
  "i2v.effectPanRight": "向右平移",
  "i2v.effectPanUp": "向上平移",
  "i2v.generateBtn": "生成视频",
  "i2v.generating": "生成中",
  "i2v.progressHint": "正在渲染帧，请稍候...",
  "i2v.success": "视频生成成功！",
  "i2v.download": "下载视频",
  "i2v.regenerate": "重试",
  "i2v.error": "视频生成失败。请重试。",
  "i2v.invalidFile": "请选择有效的图像文件。",
  "i2v.fileTooLarge": "文件太大。最大 20MB。",

  // 游客横幅
  "guest.remaining": "🎁 游客免费试用：剩余 {{remaining}}/5 次",
  "guest.exhausted": "免费试用次数已用完，请登录继续使用",
  "guest.loginToUnlock": "登录解锁无限生成",
  "guest.loginButton": "登录 / 注册",
  "guest.welcomeBack": "欢迎回来，{{name}}！所有生成功能已解锁。",

  // 页脚
  "footer.stayUpdated": "保持更新",
  "footer.newsletter": "获取有关新功能和 AI 图像生成技巧的最新更新",
  "footer.emailPlaceholder": "您的电子邮件地址",
  "footer.subscribe": "订阅",
  "footer.product": "产品",
  "footer.features": "功能",
  "footer.company": "公司",
  "footer.legal": "法律",
  "footer.aiGenerator": "AI 生成器",
  "footer.pricing": "定价",
  "footer.textToImage": "文本生成图像",
  "footer.imageToImage": "图像转图像",
  "footer.styleTransfer": "风格迁移",
  "footer.aboutUs": "关于我们",
  "footer.contact": "联系我们",
  "footer.privacy": "隐私政策",
  "footer.terms": "服务条款",
  "footer.copyright": "© 2025 AI 图像生成器。保留所有权利。",
  "footer.poweredBy": "由 Readdy 提供支持",

  // Pro 横幅
  "proBanner.badge": "限时优惠",
  "proBanner.title": "解锁专业版以获得终极创作力量",
  "proBanner.subtitle": "获得 4K 分辨率、3 倍快速生成、批量处理和零广告。将您的 AI 艺术提升到新的水平。",
  "proBanner.f1": "3 倍快",
  "proBanner.f2": "4K 分辨率",
  "proBanner.f3": "批量生成",
  "proBanner.f4": "无广告",
  "proBanner.discount": "节省 48% — 限时优惠",
  "proBanner.cta": "立即升级到专业版",
  "proBanner.guarantee": "30 天退款保证",

  // 会员中心
  "member.loginRequired": "需要登录",
  "member.loginDesc": "请登录以访问您的会员中心并管理您的订阅。",
  "member.backHome": "返回首页",
  "member.freePlan": "免费计划",
  "member.proPlan": "专业计划",
  "member.currentPlan": "当前计划",
  "member.planType": "计划类型",
  "member.freePlanLabel": "免费",
  "member.resolution": "最大分辨率",
  "member.speed": "生成速度",
  "member.speedStandard": "标准",
  "member.speed3x": "3 倍快",
  "member.batch": "批量生成",
  "member.batch5": "最多 5 张",
  "member.batch20": "最多 20 张",
  "member.watermark": "水印",
  "member.noWatermark": "无水印",
  "member.hasWatermark": "有",
  "member.usageStats": "使用统计",
  "member.todayUsage": "今日使用",
  "member.totalGenerated": "累计生成",
  "member.memberSince": "会员起始日期",
  "member.upgradeTitle": "升级到专业版以获得完整体验",
  "member.upgradeDesc": "解锁 4K 分辨率、3 倍快速度、批量生成、无水印和无广告。",
  "member.upgradeCta": "升级到专业版",
  "member.proBenefits": "您的专业版权益",
  "member.benefit1": "无限图像",
  "member.benefit2": "4K 分辨率",
  "member.benefit3": "3 倍快速度",
  "member.benefit4": "批量生成",
  "member.benefit5": "无广告",
  "member.benefit6": "商业许可",
};

export default common;
